export const RANDOM_PLACEHOLDERS = [
  'Cherchez en croisant expressions, dates, références, entreprises...',
  'Essayez : "valeur locative" 24 rue du mail 75002',
  'Essayez : prestation compensatoire de "60000 euros"',
  'Essayez : contrat listes alternatives SAUF "liste électorale"',
  'Essayez : TGI 18 avril 2019 site internet "mentions légales"',
  'Essayez : Entreprise lambda "harcelement moral" 2013',
];

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * Math.floor(max));
};

export const getRandomSearchPlaceholder = () => {
  const size = RANDOM_PLACEHOLDERS.length;
  return RANDOM_PLACEHOLDERS[getRandomInt(size - 1)];
};
